import React from 'react';
import classnames from 'classnames';

type StudyPreviewCardProps = {
  studyInstanceUid: string;
  dateLabel: string;
  description?: string;
  imageSrc?: string;
  isCurrentStudy: boolean;
  isSelected: boolean;
  isCompareTarget: boolean;
  onClick: (event: React.MouseEvent) => void;
  onDoubleClick?: () => void;
};

function StudyPreviewCard({
  dateLabel,
  description,
  imageSrc,
  isCurrentStudy,
  isSelected,
  isCompareTarget,
  onClick,
  onDoubleClick,
}: StudyPreviewCardProps) {
  return (
    <button
      type="button"
      className={classnames(
        'study-preview-card group relative flex w-full flex-col overflow-hidden rounded border border-[#e5e5e5] bg-black text-left transition-shadow',
        (isSelected || isCompareTarget) && 'ring-2 ring-[#0f91b2] ring-offset-1'
      )}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      data-cy="study-preview-card"
    >
      <div className="study-preview-card__image relative aspect-[166/191] w-full">
        {imageSrc ? (
          <img
            src={imageSrc}
            alt={description || 'Study preview'}
            className="h-full w-full object-contain"
            crossOrigin="anonymous"
          />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-black">
            <div className="h-8 w-8 animate-pulse rounded-full bg-neutral-700" />
          </div>
        )}
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent px-2 pb-2 pt-6">
          <p className="text-[9px] font-semibold leading-[13.5px] text-white">{dateLabel}</p>
          {description ? (
            <p className="mt-0.5 truncate text-[9px] text-white/70">{description}</p>
          ) : null}
        </div>
      </div>
    </button>
  );
}

export { StudyPreviewCard };
